import {
  FONT_TYPES,
  AUDIO_TYPES,
  IMG_TYPES,
  VIDEO_TYPES,
  ZIP_TYPES,
  PSD_TYPES,
  PDF_TYPES,
  HTML_TYPES,
} from "./constants";

export const isAudioType = (filetype: string) => {
  return AUDIO_TYPES.includes(filetype);
};

export const isFontType = (filetype: string) => {
  return FONT_TYPES.includes(filetype);
};

const isImageType = (filetype: string) => {
  return IMG_TYPES.includes(filetype);
};

export const isVideoType = (filetype: string) => {
  return VIDEO_TYPES.includes(filetype);
};

export const isZipType = (filetype: string) => {
  return ZIP_TYPES.includes(filetype);
};

export const isPhotoshopType = (filetype: string) => {
  return PSD_TYPES.includes(filetype);
};

export const isPDFType = (filetype: string) => {
  return PDF_TYPES.includes(filetype);
};

export const isHTMLType = (filetype: string) => {
  return HTML_TYPES.includes(filetype);
};

export const isValidAssetTypeToPreview = ({ filetype }: WDAsset) => {
  return isImageType(filetype) || isVideoType(filetype) || isPDFType(filetype);
};
